import type { Lang } from '@/types/lang'
import { MCP_URL } from '../guideContent'

/**
 * Готовая просьба для Claude Code (как у Higgsfield): автор вставляет её в чат,
 * команды Claude Code выполняет сам. Вход в студию — всегда за человеком,
 * поэтому второй шаг — просьба к автору, а не команда.
 */
const PROMPTS: Record<Lang, string> = {
  ru: `Подключи мне OA Studio, чтобы я мог собирать курсы прямо отсюда.
1. Добавь коннектор: выполни \`claude mcp add --transport http academy ${MCP_URL}\`.
2. Попроси меня набрать \`/mcp\`, выбрать сервер academy и войти в студию как автор в открывшемся браузере.
3. Когда вход пройдёт, проверь подключение командой \`claude mcp list\`.
Как всё будет готово, напиши мне.`,
  en: `Set up OA Studio for me so I can build courses right from here.
1. Add the connector: run \`claude mcp add --transport http academy ${MCP_URL}\`.
2. Ask me to type \`/mcp\`, select the academy server and sign in to the studio as an author in the browser that opens.
3. Once signed in, check the connection with \`claude mcp list\`.
Let me know when it’s ready.`,
}

export const claudeCodePrompt = (lang: Lang): string => PROMPTS[lang]
